import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { Flex } from '@percent/lemonade'
import { useQuery } from '@percent/utility'
import { AutoAssignmentRules } from './tables/AutoAssignmentRules'

export function GrantsAssignmentsRulesContainer() {
  const { grantProgramService } = useServices()
  const { errorMessage, data, isLoading, refetch } = useQuery(
    ['tasks-auto-assignment-rules', 'all'],
    grantProgramService.getAutoAssignmentRules,
    {}
  )

  return (
    <Flex direction="column" gap="md" style={{ width: '100%' }}>
      <AutoAssignmentRules rules={data ?? []} isLoading={isLoading} errorMessage={errorMessage} refresh={refetch} />
    </Flex>
  )
}
